import FleetMenuLinks from './FleetMenuLinks';
import LogoutMenuLinks from './LogoutMenuLinks';
import PrimaryMenuLinks from './PrimaryMenuLinks';
import RentalMenuLinks from './RentalMenuLinks';
import ViewOnScreen from '../../components/view-on-screen/ViewOnScreen';
import { Arrow, ArrowContainer, DropdownMenu, MenuContentRoot } from './Style';
import { isAuthenticated } from '../../utils/authUtils';
import { RootState, useAppSelector } from '../../redux/store';

function UserMenuContent() {
  const authState = useAppSelector((state: RootState) => state.auth);

  return (
    <MenuContentRoot>
      <ViewOnScreen screen={{ up: 'xs' }}>
        <ArrowContainer>
          <Arrow></Arrow>
        </ArrowContainer>
      </ViewOnScreen>
      <DropdownMenu>
        <PrimaryMenuLinks />
        {isAuthenticated(authState.loginStatus) && (
          <>
            <FleetMenuLinks />
            <RentalMenuLinks />
            <LogoutMenuLinks />
          </>
        )}
      </DropdownMenu>
    </MenuContentRoot>
  );
}

export default UserMenuContent;
